import type {IssueBodyHeaderAuthor$key} from './__generated__/IssueBodyHeaderAuthor.graphql'
import {IssueBodyHeaderAuthor} from './IssueBodyHeaderAuthor'

type IssueBodyAuthorAvatarProps = {author: IssueBodyHeaderAuthor$key | null}

export function IssueBodyAuthorAvatar({author}: IssueBodyAuthorAvatarProps) {
  return author ? <IssueBodyHeaderAuthor author={author} /> : null
}

try{ IssueBodyAuthorAvatar.displayName ||= 'IssueBodyAuthorAvatar' } catch {}